import { Grid, Typography } from "@mui/material";
import { PaymentIcons } from "../payment-icons";
import { Section } from "./section";
import { useTranslation } from "next-i18next";
import React from "react";
export const Payments = () => {
    const { t } = useTranslation("c-common");
    return (React.createElement(Section, { title: "Sicher bezahlen" },
        React.createElement(Grid, { alignItems: "center", columnSpacing: { sm: 6, md: 8 }, container: true, justifyContent: { xs: "flex-start", md: "space-between" }, rowSpacing: { xs: 3, md: 2 } },
            React.createElement(Grid, { item: true, xs: 12, md: 7 },
                React.createElement(Typography, { variant: "body1" }, t("desc", "Unsere Seite ist kompatibel mit gängigen modernen Zahlungsdienstleistern. Wir verwenden SSL für sichere Transaktionen."))),
            React.createElement(Grid, { item: true, xs: 12, md: 5 },
                React.createElement(PaymentIcons, { sx: { maxWidth: { xs: "24rem", md: "unset" } } })))));
};
//# sourceMappingURL=payments.js.map